import type { PropsWithChildren } from "react";
import "react-toastify/ReactToastify.min.css";

export const ToastProvider = ({ children }: PropsWithChildren) => {
  return children;
};
